<template>
    <div id="quote" class="container-fluid">
        <div class="row">
            <div class="col-xs-12 col-md-3 col-md-offset-3">
                <img class="img" src="../assets/cuadro_blanco.png" alt="" width="100%">
            </div>
            <div class="col-xs-12 col-md-6 col-md-offset-3 text-center">
                <h1>{{ titulo }}</h1>
                <h6>{{subtitulo}}</h6>
            </div>
        </div>
        <!-- <img src="../assets/foto3.jpg" alt="" width="100%"> -->
    </div>
</template>

<script>
export default {
    name: 'quote',
    data() {
        return {
            titulo: 'we believe',
            subtitulo: 'that talent is the main key to success'
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
    font-weight: bold;
    color: #333434;
    position: relative;
    text-align: center;
    padding-top: 180px;
}

h6 {
    font-weight: bold;
    color: #333434;
    position: relative;
    text-align: center;
    padding-top:20px;
}

.img {
    text-align: center;
    position: absolute;
    padding-top: 150px;
}

.container-fluid {
    height: 80vh;
    margin: 0px;
    padding: 0px;
    background-image: url("../assets/foto3.jpg");
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.row {
    padding-top: 150px;
}

.text-center{
    padding-top:25px;
}


/*media */

@media screen and (max-width: 1450px) {
    .row {
        padding-top: 40px;
    }

    .text-center{
    padding-top:0px;
}

}

/* horizontal tablet */
@media screen and (max-width: 1024px)
{
    .img{
        display: none;
        /* width: 120% !important; */
    }

    h1, h6{
        text-shadow: 3px 3px 10px #FFF;
    }

    h6{
        font-size: 12pt;
    }
}




/* tablet */

@media screen and (max-width: 991px) {
    img{
        display: none;
    }

    h1{
        font-size: 40pt;
        margin-top:130px;
        text-shadow: unset;
    }

    h6{
        font-size: 16pt;
        text-shadow: unset;
    }
}



/* mobile */

@media screen and (max-width: 767px) {
    .container-fluid {
        background-attachment: unset;
    }

    img {
        display: none;
    }

    h1,
    h6 {
        padding: 0px;
        padding-bottom: 20px;
        margin: 0px;
        top: 220px;
        color: white;
    }

    h1{
        font-size: 30pt;
    }

    h6{
        font-size: 14pt;
    }
}

/*mobile horizontal*/
@media screen and (max-width: 737px){
    h1{
        top:70px !important;
    }

    h6{
        top:90px !important;
    }
}

/*smaller mobile horizontal*/
@media screen and (max-width: 569px){
    h1{
        top:50px !important;
    }

    h6{
        top:50px !important;
    }
}

@media screen and (max-width: 415px) {
    h1{
        top:180px !important;
    }

    h6{
        top:180px !important;
    }
}

@media screen and (max-width: 330px) {

    h1{
        margin-top: 100px;
    }

    h6{
        margin: 0px;
        padding: 0px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/quote.vue